import React from "react";

import SignInComponent from "../../components/Authentication/AuthComponents/SignInComponent";

const SignInPage = () => {
  return <SignInComponent />;
};

export default SignInPage;
